import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(price);
}

export function formatDate(dateString) {
  return new Intl.DateTimeFormat('fr-FR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date(dateString));
}

export function getConditionLabel(condition) {
  const labels = {
    parfait: 'Parfait état',
    excellent: 'Excellent état',
    bon: 'Bon état',
    correct: 'État correct',
  };
  return labels[condition] || condition;
}

export function getConditionDescription(condition) {
  const descriptions = {
    parfait: 'Aucune trace d\'usure. Comme neuf.',
    excellent: 'Légères traces d\'utilisation, invisible à distance.',
    bon: 'Traces d\'usure visibles mais n\'affectant pas les performances.',
    correct: 'Usure marquée mais raquette fonctionnelle.',
  };
  return descriptions[condition] || '';
}

export function getLevelLabel(level) {
  const labels = {
    debutant: 'Débutant',
    intermediaire: 'Intermédiaire',
    avance: 'Avancé',
    expert: 'Expert',
  };
  return labels[level] || level;
}

export function getShapeLabel(shape) {
  const labels = {
    ronde: 'Ronde (Contrôle)',
    diamant: 'Diamant (Puissance)',
    goutte: 'Goutte (Polyvalente)',
  };
  return labels[shape] || shape;
}

export function truncate(str, length = 100) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}
